import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconAltitudeSizeS from './IconAltitude_size_s';

const props: CreateIconArguments = {
  l: IconAltitudeSizeS,
  m: IconAltitudeSizeS,
  s: IconAltitudeSizeS,
  xs: IconAltitudeSizeS,
  name: 'IconAltitude',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
